import {Icon} from "@blueprintjs/core";

const StopDot = ({color}: {color: string}) => {
  return (
    <div
      data-testid="stop-dot"
      style={{
        width: "14px",
        height: "14px",
        borderRadius: "50%",
        backgroundColor: "white",
        border: `2px solid ${color}`,
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <Icon icon="dot" color={color} size={16} />
    </div>
  );
};

export default StopDot;
